export default "__VITE_ASSET__D0qyypdV__"